import {useCallback, useRef} from 'react'
import {reportIssueFieldsUsage, type IssueFieldsUsageEvent} from './issue-fields-analytics'

export function useIssueFieldsAnalytics() {
  const interactionStartRef = useRef<number | null>(null)

  const markInteractionStart = useCallback(() => {
    interactionStartRef.current = Date.now()
  }, [])

  const reportUsage = useCallback((event: Omit<IssueFieldsUsageEvent, 'interactionDuration'>) => {
    const interactionDuration =
      interactionStartRef.current !== null ? Date.now() - interactionStartRef.current : undefined
    interactionStartRef.current = null
    reportIssueFieldsUsage({
      ...event,
      interactionDuration,
    })
  }, [])

  return {markInteractionStart, reportUsage}
}
